/**
 * default time required (in ms) to delay a debounce
 */
export const DEFAULT_DEBOUNCE_MS = 700
